<template>
  <v-container fluid>
    <h2 class="mb-3 mb-5 text-xs-center weblog-tit">اخبار جدید</h2>
    <v-layout row wrap justify-space-around align-center>
      <v-flex xl6 lg6 md6 sm12 xs12>
        <v-layout align-center>
          <v-item-group v-model="window1" class="shrink mr-4" mandatory tag="v-flex">
            <v-item v-for="n1 in length1" :key="n1">
              <div slot-scope="{ active, toggle }">
                <v-btn :input-value="active" icon @click="toggle">
                  <v-icon color="indigo darken-1">bookmark</v-icon>
                </v-btn>
              </div>
            </v-item>
          </v-item-group>

          <v-flex>
            <v-window v-model="window1" class="elevation-1" vertical>
              <v-window-item v-for="n1 in News1" :key="n1" class="mb-2">
                <v-card flat>
                  <v-card-text>
                    <v-layout align-center mb-3>
                      <v-avatar color="deep-purple lighten-2" class="mr-3">
                        <v-icon dark>notifications</v-icon>
                      </v-avatar>
                      <strong
                        class="title mr-3"
                        style="font-family: IRANSans !important;"
                      >{{ n1.weblogTitle }}</strong>
                      <v-spacer></v-spacer>
                      <v-btn icon>
                        <v-icon>mdi-account</v-icon>
                      </v-btn>
                    </v-layout>

                    <p class="justify-end">{{n1.webLogMsg}}</p>
                  </v-card-text>
                </v-card>
              </v-window-item>
            </v-window>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xl6 lg6 md6 sm12 xs12>
        <v-layout align-center>
          <v-item-group v-model="window2" class="shrink mr-4" mandatory tag="v-flex">
            <v-item v-for="n2 in length2" :key="n2">
              <div slot-scope="{ active, toggle }">
                <v-btn :input-value="active" icon @click="toggle">
                  <v-icon color="indigo darken-1">bookmark</v-icon>
                </v-btn>
              </div>
            </v-item>
          </v-item-group>

          <v-flex>
            <v-window v-model="window2" class="elevation-1" vertical>
              <v-window-item v-for="n2 in News2" :key="n2">
                <v-card flat>
                  <v-card-text>
                    <v-layout align-center mb-3>
                      <v-avatar color="deep-purple lighten-2 " class="mr-3">
                        <v-icon dark>notifications</v-icon>
                      </v-avatar>
                      <strong
                        class="title mr-3"
                        style="font-family: IRANSans !important;"
                      >{{ n2.weblogTitle }}</strong>
                      <v-spacer></v-spacer>
                      <v-btn icon>
                        <v-icon>mdi-account</v-icon>
                      </v-btn>
                    </v-layout>

                    <p class="justify-end">{{n2.webLogMsg}}</p>
                  </v-card-text>
                </v-card>
              </v-window-item>
            </v-window>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {};
</script>

<style scoped>
</style>
